import { useEffect, useState, useRef } from 'react';
import { Modal, Input, Select } from 'antd';

import '../../createAuthorizationCode/index.less';
import * as api from '@/services/enterprise';
import ProjectApplication from '../../projectApplication';

const { Option } = Select;

const UpdateAuthorizationCode = (props: any) => {
  const {
    handleUpdateAuCodeOK,
    handleUpdateAuCodeCancel,
    setUpdateDurationeNum,
    setUpdateApplications,
    auCode,
    auCodeInfo,
    // plainOptions,
    // defaultCheckedList,
    units,
    datas,
  } = props;
  // 获取项目级应用全量列表
  // const [plainOptions, setPlainOptions] = useState([]);
  // let auCodeArray: any = [];
  // const getPerList = async () => {
  //   const res = await api.getPermissionsList('2');
  //   if (res.code === 200 && res.success) {
  //     res.data.details.map((item: any) => {
  //       auCodeArray.push({
  //         label: item.name,
  //         value: item.code,
  //       });
  //     });
  //     auCodeArray[0].disabled = true;
  //     console.log('编辑授权码权限列表', res,auCodeArray);
  //     console.log('auCodeArray', auCodeArray);
  //     // setPlainOptions(auCodeArray);
  //   } else {
  //     message.error('获取项目级权限列表失败');
  //   }
  // };
  // console.log('[auCodeArray[0]?.value]', plainOptions[0]);
  // 设置有效期
  const [inputDurationStatus, setInputDurationStatus] = useState('');
  const onInputDurationNum = (e: any) => {
    const num = Number(e.target?.value);
    console.log('输入', e.target?.value, num);
    if (num > 120 || num < 1 || isNaN(num) || num % 1 !== 0) {
      setInputDurationStatus('error');
    } else {
      setUpdateDurationeNum(e.target.value);
      setInputDurationStatus('');
    }
  };

  // 项目级应用
  // const defaultCheckedList = auCodeInfo.projectApplications;
  //  console.log('defaultCheckedList',defaultCheckedList)
  // const options = [
  //   { label: '项目管理', value: 'project', disabled: true },
  //   { label: '模型协同', value: 'cloud_model' },
  //   { label: '审核决策', value: 'audit_decision' },
  //   { label: '数字营销', value: 'digital_marketing' },
  //   { label: '数字营销Pad端', value: 'digital_marketing_pad' },
  // ]; // 全部选项
  // const onOptionChange = (list: any) => {
  //   console.log('点击选项', list, defaultCheckedList);
  //   setUpdateApplications(list);
  // };

  // useEffect(()=>{
  // })

  useEffect(() => {
    // console.log('auCodeInfo',auCodeInfo)
    // getPerList();
    // setUpdateApplications(
    //   auCodeInfo.projectApplications.map((item: any) => {
    //     return item.code;
    //   }),
    // );
    setUpdateDurationeNum(auCodeInfo.expiredDuration);
    console.log('auCodeInfo', auCodeInfo);
  }, []);

  const addonAfter = (
    <Select defaultValue={auCodeInfo.timeUnite === 'day' ? '天' : '月'} disabled>
      {units?.map((u: any) => (
        <Option value={u.code}>{u.name}</Option>
      ))}
    </Select>
  );

  return (
    <>
      <Modal
        title="编辑授权码"
        visible={true}
        onOk={() => handleUpdateAuCodeOK()}
        onCancel={handleUpdateAuCodeCancel}
        width={600}
        className="updateAuthorizationCodeModal"
      >
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            授权码
          </div>
          <div className="modalInput" style={{ margin: 0, paddingTop: '4px' }}>
            <span
              style={{
                lineHeight: '32px',
                height: '32px',
                background: '#f2f3f5',
                padding: '2px 8px',
              }}
            >
              {auCode}
            </span>
          </div>
        </div>
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            项目级应用
          </div>
          <div className="modalInput" style={{ margin: 0 }}>
            {datas?.map((tr: any, i: number) => (
              <ProjectApplication
                key={tr.code}
                datas={tr}
                index={i}
                setOwnProjectApplications={setUpdateApplications}
              ></ProjectApplication>
            ))}
          </div>
        </div>
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            有效期
          </div>
          <div className="modalInput" style={{ margin: 0, marginTop: '8px' }}>
            <Input
              placeholder="输入数量"
              onChange={onInputDurationNum}
              addonAfter={addonAfter}
              status={inputDurationStatus === 'error' ? inputDurationStatus : undefined}
              defaultValue={auCodeInfo.expiredDuration}
              style={{ width: '140px' }}
              className="modalCodeInput"
              disabled
            />
            {inputDurationStatus === 'error' ? (
              <div className="inputMention" style={{ color: '#ff4d4f', fontSize: '12px' }}>
                请输入1-120的正整数
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UpdateAuthorizationCode;
